<template>
  <div class="sysPlanList">
    <main-right-popup-common :titleName="'公共方案库'" ref="mainRightPopupCommon" @loadData="loadData">
      <template v-slot:typeDiv>
        <div class="radioBox">
          <el-radio v-model="myLineInquiry" :label="1" @change="getListData('empty')">全部</el-radio>
          <el-radio v-model="myLineInquiry" :label="2" @change="getListData('empty')">我提交的</el-radio>
          <el-radio v-model="myLineInquiry" :label="3" @change="getListData('empty')">公司提交的</el-radio>
        </div>
      </template>
      <template v-slot:searchDiv>
        <div class="searchDiv">
          <div class="firstLineSearch">
            <span class="boldFont">出发地&nbsp;</span>
            <el-input style="width: 1.48rem" size="mini" />
            <span style="margin-left: 0.1rem;">天数&nbsp;</span>
            <el-input style="width: 0.66rem" size="mini" />
            <span style="margin-left: 0.1rem;">人数&nbsp;</span>
            <el-input style="width: 0.69rem" size="mini" />
          </div>
          <div style="margin-top: 10px" class="firstLineSearch">
            <span class="boldFont">目的地&nbsp;</span>
            <el-input style="width: 1.48rem" size="mini" />
            <el-input style="width: 2.05rem;margin-left: 0.1rem;" size="mini" placeholder="城市/国家/供应商/团号"/>
            <span class="searchTravel" @click="getListData('empty')">搜索</span>
          </div>
        </div>
      </template>
      <template v-slot:dataDiv>
        <div v-for="(item,index) in informationList" :key="index">
          <plan-list-info :item="item" :planId="0" @replaceStroke="replaceStroke" :showDelete="false" :index="index"
            @copyPlan="copyPlan"></plan-list-info>
        </div>
      </template>
    </main-right-popup-common>
    <plan-detail-dialog ref="planDetail"></plan-detail-dialog>
    <create-plan ref="createPlan"></create-plan>
  </div>
</template>

<script>
import mainRightPopupCommon from '../mainRightPopupCommon.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import {mapState} from "vuex"
import PlanDetailDialog from '../../leftMoudle/dialog/planDetailDialog.vue'
import PlanListInfo from './child/planListInfo.vue'
import CreatePlan from '../../leftMoudle/dialog/createPlan.vue'
export default {
  components: { mainRightPopupCommon, PlanDetailDialog,PlanListInfo ,CreatePlan},
  computed:{
    ...mapState(['planId'])
  },
  data(){
    return{
      myLineInquiry:1,
      informationProductPage:1,
      informationList:[]
    }
  },
  methods:{
    copyPlan(item){
      this.$refs.createPlan.creatTripDate = this.dateFormatYMD(item.budgetMains[item.showIndex].departureDate,"-")
      this.$refs.createPlan.useNumber =item.budgetMains[item.showIndex].useNumber
      this.$refs.createPlan.creatTripDays =item.planDay
      this.$refs.createPlan.showCreatePlanType = false
      this.$refs.createPlan.showPlanDay =false
      this.$refs.createPlan.showEndTripDate = false
      this.$refs.createPlan.oldPlanObj = item.budgetMains[item.showIndex]
      this.$refs.createPlan.beforOpen()
    },
    loadData(){
      this.informationProductPage++;
      this.getListData()
    },
    getListData(type){
      this.$refs.mainRightPopupCommon.loading = true
      if(type=='empty'){
        this.informationProductPage = 1;
        this.informationList = []
      }
      new PlanApi('plan').sysPlanList({
        page:this.informationProductPage,
        size:10,
        q:{
          
        }
      }).then(res => {
        this.$set(this.$refs.mainRightPopupCommon,'loading',false)
        if (res.status == 200) {
          res.data.records.forEach(element => {
            this.$set(element,'showIndex',0)
          });
          this.informationList = [...this.informationList,...res.data.records]
          if(res.data.records.length<10){
            this.$refs.mainRightPopupCommon.isMore = true
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    replaceStroke(item,itemThree){
      this.$refs.planDetail.openDialog(item,itemThree)
    },
  },
  mounted(){
    this.getListData('empty')
  }
}
</script>

<style lang="scss" scoped>
.sysPlanList /deep/ .product_body{
  top: 1.35rem !important;
}
.radioBox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 6.5rem;
}
.searchDiv{
  .firstLineSearch{
    font-size: 0.12rem;
    /deep/ .el-range-separator{
      transform: translateX(-4px);
    }
  }
  .searchTravel {
    display: inline-block;
    height: 0.28rem;
    line-height: 0.28rem;
    margin-left: 0.2rem;
    text-shadow: 2px 2px 5px #999;
    color: #f54402;
    font-weight: bold;
    cursor: pointer;
  }
}
.new_myPlan_box:hover{
  box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);
}
.new_myPlan_box{
  position: relative;
  margin-top: 0.2rem;
  display: flex;
  .box_title{
    position: absolute;
    top: -0.1rem;
    right: 0;
    height: 0.22rem;
    display: flex;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    box-shadow: 0px 2px 6px 0px rgba(0 ,0 ,0 , 0.08);
    justify-content: flex-end;
    font-size:0.12rem;
    background-color: white;
    padding-left: 0.1rem;
    z-index: 3;
    .editing{
      font-weight: bold;
      color:#DB4E1A;
      margin-right:0.15rem;
    }
    .planIdBox{
      font-weight: bold;
      color:#02A0C6;
      margin-right:0.15rem;
    }
    .avatar{
      width:0.2rem;
      height: 0.2rem;
      border-radius:50%;
      margin-right:0.05rem;
    }
    .userName{
      color:#212121;
      margin-right: 0.15rem;
    }
    .planNumber{
      color:#212121;
      margin-right: 0.15rem;
      .number{
        color: #757575 ;
        margin-left: 0.05rem;
      }
    }
  }
  .left_img_box{
    width:1.76rem;
    height:1.17rem;
    position: relative;
    font-size: 0.12rem;
    .xundan_box{
      position: absolute;
      bottom:35px;
      right:11px;
      font-size:12px;
      color:white;
      height:19px;
      line-height: 19px;
      padding:0px 10px;
      padding-right:15px;
      border-radius:4px;
      background: rgba(230, 74, 25, 0.80);
      .xundan_icon{
          height:19px;
          width: 19px;
          border:1px solid rgba(230, 74, 25, 0.80);
          background:white;
          font-size:12px;
          color:#101010;
          text-align: center;
          line-height:19px;
          position:absolute;
          top:0;
          right:-5px;
          border-radius:50%;
      }
    }
    .copy_button{
      position:absolute;
      top:0.05rem;
      width: 0.2rem;
      height:0.2rem;
      border-radius: 50%;
      background:white;
      display: flex;
      cursor:pointer;
      img{
        margin: auto;
        width:0.15rem;
        height:0.15rem;
      }
    }    
    img{
      border-radius:5px 0 0 5px;
    }
    .planIndex_box{
      position:absolute;
      top:0;
      left:0;
      display: flex;
      .box_left{
        width:0.3rem;
        height:0.24rem;
        background: #E64A19;
        border-radius:5px 0 0 0;
        display: flex;
        img{
          margin:auto;
          width:0.12rem;
          height:0.12rem;
        }
      }
      .box_right{
        width:0.62rem;
        height:0.24rem;
        color:#869AA6;
        border-radius:0px 0px 5px 0px;
        border:1px solid #E64A19;
        line-height: 0.22rem;
        background:white;
        text-align:center;
      }
    }
  }
  .right_info_box{
    margin-left:15px;
    .lunbo_box{
      width:5.8rem;
      /deep/ .el-carousel__indicators{
        display: none;
      }
    }
    .right_planName{
      margin-top:0.18rem;
      color:#212121;
      font-size:0.16rem;
      font-weight:bold;
      margin-right:0.1rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      .greenPlace{
        color: #26505A;
      }
    }
    .right_price_box{
      margin-top:5px;
      height:0.49rem;
      width:100%;
      border-radius:3px;
      display: flex;
      align-items: center;
      .start_time_box{
        width: 1.02rem;
        height: 0.52rem;
        background: #F9F8F8;
        border-radius:5px;
        padding:0 0.125rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        .time_top{
          font-size:0.15rem;
          color: #296776;
        }
        .time_bottom{
          width:100%;
          display: flex;
          margin-top:0.02rem;
          justify-content: space-between;
          font-size:0.12rem;
          .left{ 
            color:#000000;
          }
          .right{
            color: #296776;
            font-weight: normal;
          }
        }
      }
      .grayLine{
        border-right:1.5px dotted #bbb;
        margin:0 0.15rem;
        height: 0.4rem;
      }
      .one{
        width:0.9rem;
      }
      .two{
        width:1.3rem;
      }
      .price_items{
        display: flex;
        flex-direction: column;
        align-items: center;
        .number{
          font-weight: bold;
          color: #7F7F7F;
        }
        .black_font{
          color:#101010;
        }
        .title{
          font-size:0.12rem;
          color:#7F7F7F;//rgba(230, 74, 25, 0.80)
          margin-top: 0.03rem;
        }
      }
    }
  }
}
.changeLunBox{
  display: flex;
  align-items: center;
  margin-top:8px;
  justify-content: center;
  li{
    width:8px;
    height:8px;
    border-radius: 50%;
    cursor: pointer;
    background:#D6D6D6;
    margin-right: 4px;
  }
  .checkedLi{
    background: #8C8C8C;
  }
}
</style>